var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-nowrap"},[_c('entity-edit-control',{attrs:{"entity":_vm.entity,"entity-name":_vm.entityName}}),_c('span',[_vm._v(" ")]),_c('entity-delete-control',{attrs:{"entity":_vm.entity,"entity-name":_vm.entityName,"refs":_vm.refs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }